export const SET_CURRENT_PLAN_ID_TO_SHOW_DETAILS = 'SET_CURRENT_PLAN_ID_TO_SHOW_DETAILS';
